import { render, staticRenderFns } from "./LastBookingsListing.vue?vue&type=template&id=35080564&"
import script from "./LastBookingsListing.vue?vue&type=script&lang=js&"
export * from "./LastBookingsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports